import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'

const CurrentDay = ({
  weekday,
  date,

  temperature,
  minTemp,
  maxTemp,
  humidity,
  weatherIcon,
  weatherDescription,
  population,
  pressure,
  description,
  coordLat,
  coordLon,
  location,
}) => (
  <div className='forecast_card'>
    <div className='row'>
      <div
        className='  col-sm-12
        col-md-4
        col-lg-4
        col-xl-4'
      >
        <div className='city'>
          <h5>{location}</h5>
        </div>
        <div className='date'>
          <h5>{date}</h5>
        </div>
        <div className='temp_icon'>
          <div className='temp'>
            <h5>{temperature} &deg;C</h5>
          </div>
          <div className='icon'>
            <img src={weatherIcon} alt={weatherDescription} />
          </div>
        </div>
      </div>
      <div
        className='  col-sm-12
        col-md-4
        col-lg-4
        col-xl-4'
      >
        <div className='others'>
          <h5>
            City Population: <span>{population}</span>
          </h5>
          <h5>
            City Coordinate(Latitude): <span>{coordLat}</span>
          </h5>
          <h5>
            City Coordinate(Lontitude): <span>{coordLon}</span>
          </h5>
          <h5>
            Weather Condition: <span>{weatherDescription}</span>
          </h5>
          <h5>
            Weather Description: <span>{description}</span>
          </h5>
        </div>
      </div>
      <div
        className='  col-sm-12
        col-md-4
        col-lg-4
        col-xl-4'
      >
        <div className='others'>
          <h5>
            Humidity: <span>{humidity} &deg;Pa</span>
          </h5>
          <h5>
            Pressure: <span>{pressure} &deg;Pa</span>
          </h5>
          <h5>
            Min &deg;c: <span>{minTemp}&deg;c</span>
          </h5>
          <h5>
            Max &deg;c: <span>{maxTemp}&deg;c</span>
          </h5>
        </div>
      </div>
    </div>
  </div>
)

export default CurrentDay
